import axios from "axios";
import { Config } from "../Config";
import { userAccessToken } from "../helpers";


export const fetchAllPasswords = async (filter) => {
  const { account_id, location_id, user_id, page, per_page, search_term, order_by } = filter;

  try {
    const searchParam = search_term ? `&search_term=${search_term}` : "";
    let orderBy = order_by ? `&order_by=${JSON.stringify(order_by)}` : "";
    const response = await axios.get(
      `${Config.apiServerUrl}/password-manager/all?account_id=${account_id}&location_id=${location_id}&user_id=${user_id}&page=${page}&per_page=${per_page}${searchParam}${orderBy}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const AddAndUpdatePasswordManager = async (data) => {
  try {
    const response = await axios.post(`${Config.apiServerUrl}/password-manager/store`,data,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const deletePassword = (id, account_id, practice_id) => {
  try {
    const response = axios.delete(`${Config.apiServerUrl}/password-manager/delete?account_id=${account_id}&location_id=${practice_id}&password_id=${id}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;

  } catch (error) {
    return error?.response?.data;
  }
};

export const deleteBulkPassword = async (deleteData) => {
  try {
    const response = await axios.delete(`${Config.apiServerUrl}/password-manager/bulk-delete`, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
      data: deleteData,
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};